import videoProviders from './video/video.providers';

export default angular.module('doxy.providers', [videoProviders]).name;
